import { makePublishHelper } from '../../helpers-creators';

export var eventRequested = makePublishHelper('eventRequested', 'wh.myAccount.command.dropdown.open');
//# sourceMappingURL=eventRequested.js.map